var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entityId)?_c('product-form',{attrs:{"is-new":false,"document-preview":{ id: _vm.entityId },"init-params":{}},on:{"form-close":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }